import { type FC } from "react";

import { ColoredLabel } from "widgets";

import { getBitScoreFillColor } from "../../../../app-utils/color.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const BlastScoreCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  return (
    <TableCell>
      <ColoredLabel color={getBitScoreFillColor(props.value)}>
        <span style={{ textAlign: "right" }}>{props.value}</span>
      </ColoredLabel>
    </TableCell>
  );
};

export { BlastScoreCell };
export default BlastScoreCell;
